import React, { useState } from 'react';
import { useAuth } from '../../store/AuthContext';
import { Rocket, User, LogOut, Search, Menu } from 'lucide-react';
import LaunchMissionModal from './LaunchMissionModal';

const Navbar = ({ onRefreshNeeded, searchQuery, setSearchQuery, onSearchTriggered, isMobile, onHamburger }) => {
  const { user, logout } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearchTriggered?.();
    }
  };

  const handleSearchClick = (e) => {
    e.preventDefault();
    onSearchTriggered?.();
  };

  return (
    <>
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; box-shadow: 0 0 10px rgba(226, 123, 88, 0.7); }
            50% { opacity: 0.4; box-shadow: 0 0 0px rgba(226, 123, 88, 0); }
            100% { opacity: 1; box-shadow: 0 0 10px rgba(226, 123, 88, 0.7); }
          }
          .mission-button {
            animation: blink 2s infinite ease-in-out;
          }
          .mission-button:hover {
            animation: none;
            opacity: 1;
            box-shadow: 0 0 15px rgba(226, 123, 88, 0.9);
            transform: translateY(-1px);
          }
        `}
      </style>
      
      <nav style={{
        height: '60px',
        backgroundColor: '#05070A',
        borderBottom: '1px solid #0B3D91',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {isMobile && (
            <button
              onClick={onHamburger}
              aria-label="Abrir menú"
              style={{ background: 'none', border: 'none', color: '#00CEC9', cursor: 'pointer', display: 'flex', padding: '4px' }}
            >
              <Menu size={24} />
            </button>
          )}
          <Rocket size={24} color="#E27B58" />
          <span style={{ fontWeight: 'bold', letterSpacing: '2px', fontSize: isMobile ? '15px' : '18px', fontFamily: "'Orbitron', sans-serif" }}>OPPORTUNITY</span>

          {!isMobile && (!user?.nasaProfile || user?.nasaProfile?.missionLaunch === 0) && (
            <button 
              onClick={() => setModalOpen(true)}
              className="mission-button"
              style={{
                marginLeft: '15px',
                backgroundColor: '#E27B58',
                color: 'white',
                border: 'none',
                padding: '5px 15px',
                borderRadius: '4px',
                fontFamily: "'Orbitron', sans-serif",
                fontSize: '10px',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                letterSpacing: '1px',
                transition: 'all 0.2s ease'
              }}
            >
              <Rocket size={14} />
              LAUNCH MISSION
            </button>
          )}
        </div>

      {!isMobile && (
      <div style={{
        flex: 1,
        maxWidth: '500px',
        margin: '0 40px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'rgba(45, 52, 54, 0.5)',
        padding: '5px 15px',
        borderRadius: '4px',
        border: '1px solid #2D3436'
      }}>
        <input
          type="text"
          placeholder="SEARCH MISSION ELEMENTS..."
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            padding: '5px 10px',
            width: '100%',
            outline: 'none',
            fontSize: '12px'
          }}
          value={searchQuery || ''}
          onChange={(e) => setSearchQuery?.(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div
          onClick={handleSearchClick}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginLeft: '10px' }}
        >
          <Search size={16} color="#00CEC9" />
        </div>
      </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '12px' : '20px' }}>
        {isMobile ? (
          <button
            onClick={() => setMobileSearchOpen((v) => !v)}
            aria-label="Buscar"
            style={{ background: 'none', border: 'none', color: '#00CEC9', cursor: 'pointer', display: 'flex', padding: '4px' }}
          >
            <Search size={20} />
          </button>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <User size={18} color="#00CEC9" />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>{user?.name || 'Commander'}</span>
          </div>
        )}
        <button
          onClick={logout}
          style={{
            background: 'none',
            border: 'none',
            color: '#E27B58',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            fontSize: '14px'
          }}
        >
          <LogOut size={18} />
          {!isMobile && <span>Salir</span>}
        </button>
      </div>
      </nav>

      {/* Mobile expanding search row */}
      {isMobile && mobileSearchOpen && (
        <div style={{
          position: 'fixed',
          top: '60px',
          left: 0,
          right: 0,
          zIndex: 999,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          backgroundColor: '#05070A',
          borderBottom: '1px solid #0B3D91',
        }}>
          <input
            autoFocus
            type="text"
            placeholder="Buscar..."
            style={{
              flex: 1,
              background: 'rgba(45,52,54,0.5)',
              border: '1px solid #2D3436',
              color: 'white',
              padding: '10px 12px',
              borderRadius: '4px',
              outline: 'none',
              fontSize: '14px',
            }}
            value={searchQuery || ''}
            onChange={(e) => setSearchQuery?.(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { handleKeyDown(e); setMobileSearchOpen(false); } }}
          />
          <button onClick={(e) => { handleSearchClick(e); setMobileSearchOpen(false); }} className="nasa-button" style={{ padding: '10px 14px' }}>
            <Search size={16} />
          </button>
        </div>
      )}

      <LaunchMissionModal 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)} 
        onLaunch={() => {
          if (onRefreshNeeded) onRefreshNeeded();
        }}
      />
    </>
  );
};

export default Navbar;
